module.exports = __webpack_public_path__ + "img/ct_psnre.659914b9.png";